import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Center, Flex } from '@chakra-ui/react';
import { NotificationTime } from '../../components/Time';
import { Calendar } from '@kula-ai/icons-core';
import {
  GoToInterviewButton,
  MeetingDetailsContainer,
  NotificationMessage,
} from './components';

const InterviewFillScorecard = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const { scorecard_url } = data;

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <Calendar
          size={16}
          color="var(--kula-colors-primary-500)"
          className="kula-icon"
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <NotificationMessage
          template="SCORECARD_REMINDER"
          onClose={onClose}
          notification={notification}
        />
        <MeetingDetailsContainer
          data={data}
          isCollapsable={false}
          skipInterviewers
          skipMeetingRooms
          skipLocation
          interviewSectionOrder
        />
        <Flex flexDir="column" gap="6px">
          <GoToInterviewButton
            interviewUrl={scorecard_url}
            notification={notification}
            buttonText="Fill out scorecard"
          />
        </Flex>
        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const InterviewFillScorecardNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <InterviewFillScorecard notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
